module.exports = __webpack_public_path__ + "img/student-list-showpwd.2e11edb9.svg";